import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AUTH } from "@/constants/testIds";
import { toast } from "sonner";

export default function LoginPage() {
  const { login, register } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [mode, setMode] = useState("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = mode === "login" ? await login(email, password) : await register(name, email, password);
    setLoading(false);
    if (res.ok) {
      toast.success(mode === "login" ? "Welcome back" : "Account created");
      nav(loc.state?.from || "/", { replace: true });
    } else {
      setError(res.error);
    }
  }

  return (
    <div className="min-h-[calc(100vh-4rem)] grid md:grid-cols-2">
      <div className="hidden md:block relative bg-black">
        <img src="https://images.unsplash.com/photo-1595683363301-1e94594a550d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHx0ZWNoJTIwbGlmZXN0eWxlJTIwaGVybyUyMGRhcmt8ZW58MHx8fHwxNzg0ODE3ODIyfDA&ixlib=rb-4.1.0&q=85" alt="" className="w-full h-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        <div className="absolute bottom-10 left-10 text-white">
          <div className="text-xs font-mono uppercase tracking-[0.3em] text-white/70">SSR Innovations</div>
          <div className="mt-2 font-heading font-medium text-4xl">Technology<br />meets Lifestyle.</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground">{mode === "login" ? "Welcome back" : "Create account"}</div>
          <h1 className="mt-2 font-heading font-medium text-4xl">{mode === "login" ? "Sign in" : "Get started"}</h1>
          <div className="mt-8 space-y-4">
            {mode === "register" && (
              <input data-testid={AUTH.registerName} value={name} onChange={(e) => setName(e.target.value)} required placeholder="Full name" className="w-full h-12 px-4 rounded-full bg-secondary text-sm outline-none focus:ring-2 focus:ring-electric" />
            )}
            <input data-testid={mode === "login" ? AUTH.loginEmail : AUTH.registerEmail} value={email} onChange={(e) => setEmail(e.target.value)} required type="email" placeholder="Email" className="w-full h-12 px-4 rounded-full bg-secondary text-sm outline-none focus:ring-2 focus:ring-electric" />
            <input data-testid={mode === "login" ? AUTH.loginPassword : AUTH.registerPassword} value={password} onChange={(e) => setPassword(e.target.value)} required type="password" placeholder="Password" minLength={6} className="w-full h-12 px-4 rounded-full bg-secondary text-sm outline-none focus:ring-2 focus:ring-electric" />
            {error && <div className="text-sm text-destructive">{error}</div>}
            <button data-testid={mode === "login" ? AUTH.loginSubmit : AUTH.registerSubmit} disabled={loading} className="w-full h-12 rounded-full bg-electric text-white font-medium hover:bg-electric-600 disabled:opacity-60 transition-colors">
              {loading ? "..." : mode === "login" ? "Sign in" : "Create account"}
            </button>
            <button data-testid={AUTH.toggle} type="button" onClick={() => setMode(mode === "login" ? "register" : "login")} className="w-full text-sm text-muted-foreground hover:text-foreground">
              {mode === "login" ? "No account? Create one" : "Have an account? Sign in"}
            </button>
          </div>
          <div className="mt-8 text-xs text-muted-foreground text-center">
            <Link to="/" className="hover:text-electric">← Back to store</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
